import React from 'react';
const LoadingStateComp: React.FC<{ Message: string }> = ({ Message }) => {
    return (
        <div className="flex flex-col items-center mt-20 justify-center sm:h-screen bg-transparent">
            <h2 className="text-base sm:text-[32px] text-center font-interTight leading-[125%] mb-2 font-semibold text-[#0D0D12]">
                Loading {Message}
            </h2>
            <p className="mb-8 text-sm text-gray-500">Please be patient, this will take a few seconds</p>
            <div className="relative w-16 h-16">
                <div className="absolute inset-0 border-4 border-gray-200 rounded-full"></div>
                <div className="absolute inset-0 border-4 border-t-[#020C2A] rounded-full animate-spin"></div>
            </div>
        </div>
    );
};

export default LoadingStateComp;

                